import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { AppHeader } from '@/components/shell/AppHeader';
import { SiteFooter } from '@/components/shell/SiteFooter';
import { useIsFocusMode } from '@/components/shell/focusMode';
import { isNoFooterRoute, isRunnerRoute } from '@/components/shell/routes';
import { SyncBar } from '@/components/sync/SyncIndicator';
import { usePortalSettings } from '@/lib/settings';

/**
 * App frame:
 * - header band: Acts Church wordmark + "Procedures"; theme button (signed out) or avatar menu (signed in);
 * - the sync band (only while something is waiting to sync, or just after it saved);
 * - the routed page in a centred 600 px column;
 * - a slim footer, except in the runner or while a sticky action bar is on screen.
 */
export function PortalShell() {
  const { pathname } = useLocation();
  const { settings } = usePortalSettings();
  const focus = useIsFocusMode();

  useEffect(() => {
    document.title = settings.portalName || 'Acts Procedures';
  }, [settings.portalName]);
  // New page: start at the top (the header is sticky, so a kept scroll position hides the title).
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const footer = !(focus || isNoFooterRoute(pathname));

  return (
    <div className="proc-app">
      <a href="#main" className="proc-skip">Skip to content</a>
      <AppHeader />
      <SyncBar hideStatus={isRunnerRoute(pathname)} />
      <main id="main" className="proc-content" tabIndex={-1}>
        <Outlet />
      </main>
      {footer && <SiteFooter />}
    </div>
  );
}
